import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import hz50DegMinus75 from "./components/50-hz--75-deg";
import hz50DegMinus60 from "./components/50-hz--60-deg";
import hz50DegMinus45 from "./components/50-hz--45-deg";
import hz50DegMinus30 from "./components/50-hz--30-deg";
import hz50DegMinus15 from "./components/50-hz--15-deg";
import hz50Deg0 from "./components/50-hz-0-deg";
import hz50Deg15 from "./components/50-hz-15-deg";
import hz50Deg30 from "./components/50-hz-30-deg";
import hz50Deg45 from "./components/50-hz-45-deg";
import hz50Deg60 from "./components/50-hz-60-deg";
import hz50Deg75 from "./components/50-hz-75-deg";

import hz100DegMinus75 from "./components/100-hz--75-deg";
import hz100DegMinus60 from "./components/100-hz--60-deg";
import hz100DegMinus45 from "./components/100-hz--45-deg";
import hz100DegMinus30 from "./components/100-hz--30-deg";
import hz100DegMinus15 from "./components/100-hz--15-deg";
import hz100Deg0 from "./components/100-hz-0-deg";
import hz100Deg15 from "./components/100-hz-15-deg";
import hz100Deg30 from "./components/100-hz-30-deg";
import hz100Deg45 from "./components/100-hz-45-deg";
import hz100Deg60 from "./components/100-hz-60-deg";
import hz100Deg75 from "./components/100-hz-75-deg";

import hz200DegMinus75 from "./components/200-hz--75-deg";
import hz200DegMinus60 from "./components/200-hz--60-deg";
import hz200DegMinus45 from "./components/200-hz--45-deg";
import hz200DegMinus30 from "./components/200-hz--30-deg";
import hz200DegMinus15 from "./components/200-hz--15-deg";
import hz200Deg0 from "./components/200-hz-0-deg";
import hz200Deg15 from "./components/200-hz-15-deg";
import hz200Deg30 from "./components/200-hz-30-deg";
import hz200Deg45 from "./components/200-hz-45-deg";
import hz200Deg60 from "./components/200-hz-60-deg";
import hz200Deg75 from "./components/200-hz-75-deg";

import hz400DegMinus75 from "./components/400-hz--75-deg";
import hz400DegMinus60 from "./components/400-hz--60-deg";
import hz400DegMinus45 from "./components/400-hz--45-deg";
import hz400DegMinus30 from "./components/400-hz--30-deg";
import hz400DegMinus15 from "./components/400-hz--15-deg";
import hz400Deg0 from "./components/400-hz-0-deg";
import hz400Deg15 from "./components/400-hz-15-deg";
import hz400Deg30 from "./components/400-hz-30-deg";
import hz400Deg45 from "./components/400-hz-45-deg";
import hz400Deg60 from "./components/400-hz-60-deg";
import hz400Deg75 from "./components/400-hz-75-deg";

import hz800DegMinus75 from "./components/800-hz--75-deg";
import hz800DegMinus60 from "./components/800-hz--60-deg";
import hz800DegMinus45 from "./components/800-hz--45-deg";
import hz800DegMinus30 from "./components/800-hz--30-deg";
import hz800DegMinus15 from "./components/800-hz--15-deg";
import hz800Deg0 from "./components/800-hz-0-deg";
import hz800Deg15 from "./components/800-hz-15-deg";
import hz800Deg30 from "./components/800-hz-30-deg";
import hz800Deg45 from "./components/800-hz-45-deg";
import hz800Deg60 from "./components/800-hz-60-deg";
import hz800Deg75 from "./components/800-hz-75-deg";

const principle: Slide = {
  description:
    "A plane wave, propagating from left to right, encounters an obstacle: a wall of variable inclination angle α with respect to the vertical, reaching a maximum height of 2 m. Part of the incident wave is scattered by the obstacle. Look how the scattered and incident waves interfere, hence changing the pressure field distribution. The way phenomena depend on the frequency is of particular interest! Note that 0 dB is the pressure level of the indident plane wave and +6 dB is the maximum pressure level achievable for the plane wave reflecting on a rigid boundary.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Wall",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "dropdown",
                    options: {
                      label: "Frequency",
                      labelPosition: "left",
                    },
                    items: [
                      { name: "50 Hz" },
                      { name: "100 Hz" },
                      { name: "200 Hz" },
                      { name: "400 Hz" },
                      { name: "800 Hz" },
                    ],
                  },
                  {
                    type: "dropdown",
                    options: {
                      label: "Inclination angle",
                      labelPosition: "left",
                    },
                    items: [
                      { name: "α = -75" },
                      { name: "α = -60" },
                      { name: "α = -45" },
                      { name: "α = -30" },
                      { name: "α = -15" },
                      { name: "α = 0" },
                      { name: "α = 15" },
                      { name: "α = 30" },
                      { name: "α = 45" },
                      { name: "α = 60" },
                      { name: "α = 75" },
                    ],
                  },
                ],
                extraContent: [[], [], [], [], []],
                components: [
                  [
                    hz50DegMinus75,
                    hz50DegMinus60,
                    hz50DegMinus45,
                    hz50DegMinus30,
                    hz50DegMinus15,
                    hz50Deg0,
                    hz50Deg15,
                    hz50Deg30,
                    hz50Deg45,
                    hz50Deg60,
                    hz50Deg75,
                  ],
                  [
                    hz100DegMinus75,
                    hz100DegMinus60,
                    hz100DegMinus45,
                    hz100DegMinus30,
                    hz100DegMinus15,
                    hz100Deg0,
                    hz100Deg15,
                    hz100Deg30,
                    hz100Deg45,
                    hz100Deg60,
                    hz100Deg75,
                  ],
                  [
                    hz200DegMinus75,
                    hz200DegMinus60,
                    hz200DegMinus45,
                    hz200DegMinus30,
                    hz200DegMinus15,
                    hz200Deg0,
                    hz200Deg15,
                    hz200Deg30,
                    hz200Deg45,
                    hz200Deg60,
                    hz200Deg75,
                  ],
                  [
                    hz400DegMinus75,
                    hz400DegMinus60,
                    hz400DegMinus45,
                    hz400DegMinus30,
                    hz400DegMinus15,
                    hz400Deg0,
                    hz400Deg15,
                    hz400Deg30,
                    hz400Deg45,
                    hz400Deg60,
                    hz400Deg75,
                  ],
                  [
                    hz800DegMinus75,
                    hz800DegMinus60,
                    hz800DegMinus45,
                    hz800DegMinus30,
                    hz800DegMinus15,
                    hz800Deg0,
                    hz800Deg15,
                    hz800Deg30,
                    hz800Deg45,
                    hz800Deg60,
                    hz800Deg75,
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
